import React from 'react';
import PropTypes from 'prop-types';
import { FONTS } from '../constants/Fonts';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import { getPlayerPoints, getPlayerXp } from '../utils/utils';
import LeaderboardRoundScores from './LeaderboardRoundScores';
import './HousieLeaderboardRow.css';

const RANK_MEDALS = [
  IMAGE_CONSTANTS.V2_LEADERBOARD_RANK_1,
  IMAGE_CONSTANTS.V2_LEADERBOARD_RANK_2,
  IMAGE_CONSTANTS.V2_LEADERBOARD_RANK_3,
];

/**
 * Figma 17742:25944 — leaderboard list row (rank · avatar · name · score · won pill).
 * Theme: purple glass gradient + pink accents.
 */
const HousieLeaderboardRow = ({
  rank,
  userData,
  tournamentScoring = false,
}) => {
  const avatar =
    userData?.avatar ||
    userData?.profilePic ||
    userData?.userImage ||
    IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER;
  const username = userData?.username || userData?.userName || '';
  const points = getPlayerPoints(userData);
  const prizeTitle = userData?.prizeTitle;
  const prizeIcon = userData?.prizeIcon;
  const hasPrize = Boolean(prizeTitle || prizeIcon);
  const rapCoin = getPlayerXp(userData);
  const medalSrc = rank <= 3 ? RANK_MEDALS[rank - 1] : null;

  return (
    <div
      className="housie-lb-row"
      data-node-id="18110:2758-row"
    >
      <div className="housie-lb-row__rank">
        {medalSrc ? (
          <img src={medalSrc} alt="" className="housie-lb-row__medal" />
        ) : (
          /* Figma 17742:25945 — #5b004c circle + white border */
          <div className="housie-lb-row__rank-badge">
            <span className="housie-lb-row__rank-text">#{rank}</span>
          </div>
        )}
      </div>

      <div className="housie-lb-row__player">
        <img src={avatar} alt={username} className="housie-lb-row__avatar" />
        <span className="housie-lb-row__name" style={{ fontFamily: FONTS.INTER_SEMIBOLD }}>
          {username}
        </span>
      </div>

      {tournamentScoring ? (
        <LeaderboardRoundScores
          player={userData}
          fallbackIcon={IMAGE_CONSTANTS.V2_LEADERBOARD_SCORE_IC}
          className="housie-lb-row__score"
        />
      ) : (
        <div className="housie-lb-row__score">
          <img
            src={IMAGE_CONSTANTS.V2_LEADERBOARD_SCORE_IC}
            alt=""
            className="housie-lb-row__score-ic"
          />
          <span className="housie-lb-row__score-value" style={{ fontFamily: FONTS.INTER_BOLD }}>
            {points}
          </span>
        </div>
      )}

      {/* Figma 18115:3925 — 96×34 won pill, 32×32 cropped XP coin */}
      <div className="housie-lb-row__won" data-node-id="18115:3925">
        {tournamentScoring ? (
          <>
            <span className="housie-lb-row__coin-wrap" aria-hidden="true">
              <img
                src={IMAGE_CONSTANTS.V2_PODIUM_SCORE_IC}
                alt=""
                className="housie-lb-row__won-score-ic"
              />
            </span>
            <span
              className="housie-lb-row__won-value"
              style={{ fontFamily: FONTS.INTER_BOLD }}
            >
              {points}
            </span>
          </>
        ) : hasPrize ? (
          <>
            {prizeIcon ? (
              <span className="housie-lb-row__coin-wrap" aria-hidden="true">
                <img src={prizeIcon} alt="" className="housie-lb-row__prize-ic" />
              </span>
            ) : null}
            <span
              className="housie-lb-row__won-value"
              style={{ fontFamily: FONTS.INTER_BOLD }}
            >
              {prizeTitle || '—'}
            </span>
          </>
        ) : (
          <>
            <span className="housie-lb-row__coin-wrap" data-node-id="18115:3927" aria-hidden="true">
              <img src={IMAGE_CONSTANTS.V2_XP_COIN} alt="" className="housie-lb-row__coin" />
            </span>
            <span
              className="housie-lb-row__won-value"
              style={{ fontFamily: FONTS.INTER_BOLD }}
              data-node-id="18115:3928"
            >
              {rapCoin}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

HousieLeaderboardRow.propTypes = {
  rank: PropTypes.number.isRequired,
  userData: PropTypes.object,
  tournamentScoring: PropTypes.bool,
};

export default HousieLeaderboardRow;
